interface Props {
  template: string;
  replacements: Map<string, unknown>;
}

export function TemplateOutput({template, replacements}: Props) {
  const replacementPattern = /<([^>]+)>/gi;
  const splitMarker = '%|%';

  const occurrences: unknown[] = [];
  const display = (template || '')
    .replace(replacementPattern, (matched, tag) => {
      if (replacements.has(tag)) {
        occurrences.push(replacements.get(tag));
        return splitMarker;
      }

      return matched;
    })
    .split(splitMarker)
    .map((value, i) => [value, occurrences[i]])
    .reduce((acc, cur) => [...acc, ...cur], [])
    .filter(Boolean);

  return <>{display}</>;
}
